<template>
  <v-text-field
    v-model="input"
    :rules="requiredRule"
    :label="customField.label + (required ? ' *' : '')"
    :hint="customField.hint"
    :disabled="disabled"
    :loading="loading"
    type="datetime-local"
    outlined
    persistent-hint
    :clearable="!required"
    @click:clear="clear"
  />
</template>

<style></style>

<script lang="ts">
import { Component } from "vue-property-decorator";
import CustomFieldText from "./CustomFieldText.vue";

@Component({
  components: {}
})
export default class CustomFieldDateTime extends CustomFieldText {
  clear() {
    this.input = "";
  }
}
</script>
